import React from 'react';
import { Switch, Route } from 'react-router-dom';
import QuienesSomos from '../site/QuienesSomos/WithData';
import QuienesSomosDetalle from '../site/QuienesSomos/Detalle';
import PropiedadIntelectual from '../site/PropiedadIntelectual/WithData';
import CatedraOMC from '../site/CatedraOMC/WithData';
import detalleCurso from '../site/CatedraOMC/Detalle/index';
import Actualidad from '../site/Actualidad/WithData';
import ActualidadDetalle from '../site/Actualidad/Detalle';
import Publicaciones from '../site/Publicaciones/WithData';
import PublicacionesDetalle from '../site/Publicaciones/Detalle';
import InvestigacionesDetalle from '../site/PropiedadIntelectual/detalle-investigaciones';
import Agenda from '../site/Agenda/WithData';
import Home from '../site/Home/WithData';
import Multimedia from '../site/Multimedia/WithData';
import MultimediaDetalle from '../site/Multimedia/Detalle';

const NoMatch = () => (
  <div>
    <h1>404!</h1>
  </div>
);

const Main = () => {
  return(
    <main>
      <Switch>
        <Route exact path="/" component={Home}/>

        {/* Quienes Somos */}
        <Route exact path="/quienes-somos" component={QuienesSomos}/>
        <Route exact path="/quienes-somos/:id" component={QuienesSomos}/>
        <Route exact path="/detalle" component={QuienesSomosDetalle}/>
        
        {/* Cursos */}
        <Route exact path="/propiedad-intelectual" component={PropiedadIntelectual}/>
        <Route exact path="/catedra-omc" component={CatedraOMC}/>
        <Route exact path="/detalle-curso" component={detalleCurso}/>
        <Route exact path="/detalle-curso/omc/:id" component={CatedraOMC}/>
        <Route exact path="/detalle-curso/pi/:id" component={PropiedadIntelectual}/>
        <Route exact path="/detalle-curso/csp/:id" component={PropiedadIntelectual}/>
        <Route exact path="/investigacion" component={InvestigacionesDetalle}/>
        <Route exact path="/investigacion/:id" component={PropiedadIntelectual}/>
        
        {/* Multimedia */}
		    <Route exact path="/multimedia" component={Multimedia}/>
		    <Route exact path="/galeria/fotos-seminarios/:id" component={Multimedia}/> {/* to do */}
		    <Route exact path="/galeria/videos-seminarios/:id" component={Multimedia}/> {/* to do */}
		    <Route exact path="/galeria/fotos-encuentros/:id" component={Multimedia}/> {/* to do */}
		    <Route exact path="/galeria/videos-encuentros/:id" component={Multimedia}/> {/* to do */}
		    <Route exact path="/galeria/entrevistas/:id" component={Multimedia}/> {/* to do */}
		    <Route exact path="/galeria/tesis/:id" component={Multimedia}/> {/* to do */}
        <Route exact path="/galeria" component={MultimediaDetalle}/>

        {/* Agenda */}
		    <Route path="/agenda" component={Agenda}/>

        {/* Actualidad */}
		    <Route path="/actualidad" component={Actualidad}/>
        <Route path="/noticia/:id" component={Actualidad}/>
        <Route path="/noticia/" component={ActualidadDetalle}/>
        
        {/* Publicaciones */}
        <Route exact path="/publicaciones" component={Publicaciones}/>
        <Route exact path="/publicacion" component={PublicacionesDetalle}/>
        <Route exact path="/publicacion/:id" component={Publicaciones}/>
        
        <Route component={NoMatch}/>
      </Switch>
    </main>
  )
}

export default Main;
